import styled, { css } from 'styled-components';
import { Icon } from 'view/atoms';
import { Media } from 'enums';

export const PaginationIcon = styled(Icon)<{
  isTouchStart: boolean;
  disabled?: boolean;
}>`
  user-select: none;
  cursor: pointer;
  border-radius: 8px;
  padding: 5.5px;

  background-color: ${({ isTouchStart, theme }) =>
    isTouchStart ? theme.colors.white : 'none'};

  @media ${Media.notebook} {
    padding: 4px;

    :hover {
      background-color: ${({ theme }) => theme.colors.white};
    }
  }
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.1;
      cursor: not-allowed;
      pointer-events: none;
    `}
`;
